export default "__VITE_ASSET__BhlDTXAq__"